'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.Shadows = void 0;
(function(Shadows2) {
  Shadows2["Shadow1"] = "var(--zds-shadow-1)";
  Shadows2["Shadow2"] = "var(--zds-shadow-2)";
  Shadows2["Shadow3"] = "var(--zds-shadow-3)";
  Shadows2["Shadow4"] = "var(--zds-shadow-4)";
  Shadows2["Shadow5"] = "var(--zds-shadow-5)";
  Shadows2["ShadowInset"] = "var(--zds-shadow-inset)";
  Shadows2["elevation5"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.1)";
  Shadows2["elevation6"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.2)";
  Shadows2["elevation10"] = "0px 20px 30px 0px rgba(0, 0, 0, 0.1)";
  Shadows2["elevation20"] = "0px 10px 30px 0px rgba(0, 0, 0, 0.2)";
  Shadows2["elevation30"] = "0px 10px 20px 0px rgba(0, 0, 0, 0.3)";
})(exports.Shadows || (exports.Shadows = {}));
//# sourceMappingURL=Shadows.cjs.js.map
